import React, { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import ReportGridPage from "../components/ReportGridPage";
import MultiSelect from "../ReusableComponents/MultiSelect";
import * as XLSX from "sheetjs-style";
import { useUserCapability } from "../components/ConstantReducerProvider";
import { bookingReportHeaders } from "../components/HeaderAttribute";

const BookingReport = () => {
  const { userProfileState } = useUserCapability();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const mstClientId =
    sessionStorage.getItem("MstClientId") &&
      sessionStorage.getItem("MstClientId") !== "null"
      ? Number(sessionStorage.getItem("MstClientId"))
      : 0;
  const [enquiryReportFields, setEnquiryReportFields] = useState({
    enquiryType: "",
    enquiryStatus: "",
    sourceType: "",
  });
  const [enquiryReportFieldsError, setEnquiryReportFieldsError] = useState({
    enquiryTypeError: "",
    enquiryStatusError: "",
    sourceTypeError: "",
  });
  const [bindBookingReports, setBindBookingReports] = useState([]);
  const [showTable, setShowTable] = useState(false);

  const [bindEnquiryType, setBindEnquiryType] = useState([]);
  const [bindEnquiryStatus, setBindEnquiryStatus] = useState([]);
  const [bindSourceType, setBindSourceType] = useState([]);

  const GoButton = async () => {
    const enquiryTypeValidate = enquiryReportFields.enquiryType
      ? ""
      : "Select Booking Type";
    const enquiryStatusValidate = enquiryReportFields.enquiryStatus
      ? ""
      : "Select Booking Status";

    const sourceTypeValidate = enquiryReportFields.sourceType
      ? ""
      : "Select Source Type";

    setEnquiryReportFieldsError({
      ...enquiryReportFieldsError,
      enquiryTypeError: enquiryTypeValidate,
      enquiryStatusError: enquiryStatusValidate,
      sourceTypeError: sourceTypeValidate,
    });

    let enquiryTypeArray = Array.from(
      { length: enquiryReportFields.enquiryType.length },
      (v, i) => enquiryReportFields.enquiryType[i],
    );
    let enquiryTypeResult = enquiryTypeArray.join(",");

    let enquiryStatusArray = Array.from(
      { length: enquiryReportFields.enquiryStatus.length },
      (v, i) => enquiryReportFields.enquiryStatus[i],
    );
    let enquiryStatusResult = enquiryStatusArray.join(",");

    let sourceTypeArray = Array.from(
      { length: enquiryReportFields.sourceType.length },
      (v, i) => enquiryReportFields.sourceType[i],
    );
    let sourceTypeResult = sourceTypeArray.join(",");

    if (!enquiryTypeValidate && !enquiryStatusValidate && !sourceTypeValidate) {
      const ReportData = {
        mstClientId: mstClientId,
        bookingType: enquiryTypeResult,
        bookingStatus: enquiryStatusResult,
        sourceType: sourceTypeResult,
        fromDate: fromDate,
        toDate: toDate,
      };
      const response = await BindPostAPI(
        ReportData,
        "BookingReportAPI/ReportBooking",
      );
      if (response.data.Table.length != undefined) {
        console.log("response", response.data.Table);
        setBindBookingReports(response.data.Table);
        setShowTable(true);
      } else {
        setBindBookingReports([]);
      }
    } else {
    }
  };

  const createdBy = sessionStorage.getItem("createdBy");
  const clientId = sessionStorage.getItem("MstClientId");
  const handleExport = async () => {
    try {
      // Export Function
      await exportData(
        bookingReportHeaders.map((column) => column.title),
        bindBookingReports
      );

      // ✅ Success Log
      await IUDAPI(
        {
          mstClientId: parseInt(clientId, 10),
          mstUserId: parseInt(createdBy, 10),
          sp: "Booking Report",
          action: "Excel Export",
          status: "SUCCESS",
          tableName: "",
          description: "Booking Report Excel exported successfully",
        },
        "LogAPI/IUDLog"
      );

      console.log("Booking Report Excel export completed successfully");
    } catch (error) {
      console.error("Booking Report Excel export failed:", error);

      // ❌ Failed Log
      await IUDAPI(
        {
          mstClientId: parseInt(clientId, 10),
          mstUserId: parseInt(createdBy, 10),
          sp: "Booking Report",
          action: "Excel Export",
          status: "FAILED",
          tableName: "",
          description: `Booking Report Excel export failed - ${error?.message || "Unknown Error"
            }`,
        },
        "LogAPI/IUDLog"
      );
    }
  };

  const exportData = (columns, rows) => {
    const titleRow = [
      {
        v: "Enquiry Report",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    const spacingRow = [{ v: "" }];

    const headerRow = columns.map((column) => ({
      v: column,
      s: {
        fill: { fgColor: { rgb: "000000" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));

    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const baseStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      return [
        {
          v: index + 1,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.EnquiryNo,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.EnquiryDate,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.BookingNo,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.BookingDate,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.EnquiryType,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.BookingFrom,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.BookingTo,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.EnquiryType,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.NoOfDays,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.EnquiryPersonName,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.MobileNumber,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },

        {
          v: rowData.CountryName,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },

        {
          v: rowData.State,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.City,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Address,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.BookingPersonName,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.BookingPersonMobileNumber,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },

        {
          v: rowData.BookingPersonCountry,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.BookingPersonState,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.BookingPersonCity,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.BookingPersonAddress,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.ReferralSource,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Source,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.IdProof,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.IdNumber,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.RoomTypes,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.RoomNames,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.BookingBasicTariff,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.BookingSpecialTariff,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.BookingNoOfRequiredRooms,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.BookingNoOfAdults,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.BookingNoOfChildren,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.BookingAmount,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.BookingReceivedAmount,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.BookingBalanceAmount,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.BookingPaymentType,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.BookingPaymentReferenceNumber,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.BookingStatus,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.CancelReason,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.RefundAmount,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.CancelPaymentType,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.CancelReferenceNumber,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Revenue,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
      ];
    });

    const wsData = [titleRow, spacingRow, headerRow, ...dataRows];
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    ws["!cols"] = [
      { width: 8 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 }, // dynamic width with cap
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
    ];

    // Set row heights
    ws["!rows"] = [
      { hpt: 30 },
      { hpt: 15 },
      { hpt: 15 },
      { hpt: 15 },
      { hpt: 15 },
      ...Array(rows.length).fill({ hpt: 15 }),
    ];

    // Apply borders
    const applyStyles = (ws) => {
      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellRef]) continue;

          ws[cellRef].s = {
            ...ws[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Booking Report.xlsx");
  };

  const downloadPDF = () => { };

  useEffect(() => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const automaticFromDate = `${currentYear}-01-01`;
    setFromDate(automaticFromDate);

    const formattedToDate = today.toISOString().split("T")[0];
    setToDate(formattedToDate);
  }, []);

  const enquiryReportFieldsChange = (value, name) => {
    setEnquiryReportFields({
      ...enquiryReportFields,
      [name]: value,
    });
  };
  useEffect(() => {
    BindGetEnquiryValues();
  }, []);

  const BindGetEnquiryValues = async () => {
    const data = {
      mstClientId: mstClientId,
    };
    const response = await BindPostAPI(data, "Enquiry/BindGetEnquiryValues");
    console.log("enquirydropdown:", response);
    if (response && response.data) {
      const enquiryTypeId = response.data.Table1.map((item) => ({
        value: item.MstEnquiryTypeId,
        label: item.EnquiryType,
      }));

      setBindEnquiryType(enquiryTypeId);

      const referralsourceid = response.data.Table6.map((item) => ({
        value: item.MstReferralSourceId,
        label: item.ReferralSource,
      }));
      setBindSourceType(referralsourceid);

      const allowedStatuses = ["booked", "cancel", "check in", "check out"];
      const enquiryStatus = response.data.Table11.filter((item) =>
        allowedStatuses.includes(item.EnquiryStatus.trim().toLowerCase()),
      ).map((item) => ({
        value: item.MstEnquiryStatusId,
        label: item.EnquiryStatus.trim(),
      }));
      setBindEnquiryStatus(enquiryStatus);
    }
  };

  return (
    <MainLayout pageName="4">
      <div>
        <div class="relative m-3 bg-white rounded-lg ">
          <div class="mt-3 py-4">
            <div className={mainTable.headerTitle}>
              <div className="my-2 mx-12 lg:mx-0">{`Booking Report`}</div>
            </div>
            <div class="mt-3">
              <div className={mainTable.grid3}>
                <div>
                  <MultiSelect
                    classStar="text-red-500"
                    label="Booking Type"
                    filteredOptions={bindEnquiryType}
                    classFilterLabel="p-1 flex gap-1"
                    class="custom-class"
                    placeholder={
                      enquiryReportFields.enquiryType?.length > 0
                        ? "More Selected"
                        : "Select..."
                    }
                    name="enquiryType"
                    selectedOptions={enquiryReportFields.enquiryType}
                    classDiv="relative w-full inline-block"
                    onChange={(e) => {
                      setShowTable(false);
                      enquiryReportFieldsChange(e, "enquiryType");
                    }}
                    classLabel={mainTable.labelNoWrap}
                  />
                  {enquiryReportFieldsError.enquiryTypeError && (
                    <span className="text-red-500">
                      {enquiryReportFieldsError.enquiryTypeError}
                    </span>
                  )}
                </div>
                <div>
                  <MultiSelect
                    classStar="text-red-500"
                    label="Booking Status"
                    filteredOptions={bindEnquiryStatus}
                    classFilterLabel="p-1 flex gap-1"
                    class="custom-class"
                    placeholder={
                      enquiryReportFields.enquiryStatus?.length > 0
                        ? "More Selected"
                        : "Select..."
                    }
                    name="enquiryStatus"
                    selectedOptions={enquiryReportFields.enquiryStatus}
                    classDiv="relative w-full inline-block"
                    onChange={(e) => {
                      setShowTable(false);
                      enquiryReportFieldsChange(e, "enquiryStatus");
                    }}
                    classLabel={mainTable.labelNoWrap}
                  />
                  {enquiryReportFieldsError.enquiryStatusError && (
                    <span className="text-red-500">
                      {enquiryReportFieldsError.enquiryStatusError}
                    </span>
                  )}
                </div>
                <div>
                  <MultiSelect
                    classStar="text-red-500"
                    label="Source Type"
                    filteredOptions={bindSourceType}
                    classFilterLabel="p-1 flex gap-1"
                    class="custom-class"
                    placeholder={
                      enquiryReportFields.sourceType?.length > 0
                        ? "More Selected"
                        : "Select..."
                    }
                    name="sourceType"
                    selectedOptions={enquiryReportFields.sourceType}
                    classDiv="relative w-full inline-block"
                    onChange={(e) => {
                      setShowTable(false);
                      enquiryReportFieldsChange(e, "sourceType");
                    }}
                    classLabel={mainTable.labelNoWrap}
                  />
                  {enquiryReportFieldsError.sourceTypeError && (
                    <span className="text-red-500">
                      {enquiryReportFieldsError.sourceTypeError}
                    </span>
                  )}
                </div>
              </div>
              <div class={mainTable.grid3}>
                <InputText
                  inputType="date"
                  title="From"
                  name="fromDate"
                  content={fromDate}
                  controlFunc={(e) => {
                    setShowTable(false);
                    setFromDate(e.target.value);
                  }}
                />
                <InputText
                  inputType="date"
                  title="To"
                  name="toDate"
                  content={toDate}
                  controlFunc={(e) => {
                    setShowTable(false);
                    setToDate(e.target.value);
                  }}
                />
                <div class="flex justify-start items-center mt-6">
                  <button
                    type="button"
                    onClick={() => GoButton()}
                    className={mainTable.addButton}
                  >
                    GO
                  </button>
                </div>
              </div>
            </div>
          </div>
          {showTable &&
            (bindBookingReports.length > 0 ? (
              <div className=" ">
                <ReportGridPage
                  title=""
                  header={bookingReportHeaders}
                  records={bindBookingReports}
                  handleExport={handleExport}
                  handlePDF={downloadPDF}
                // xScroll=" max-md:w-fit w-full"
                />
              </div>
            ) : (
              <div className="flex items-center justify-center">
                No record found
              </div>
            ))}
        </div>
      </div>
    </MainLayout>
  );
};

export default BookingReport;
